module.exports = __webpack_public_path__ + "static/media/background.4ea6e8db.png";